var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"size":"30","color":_vm.value ? 'kDartessRed' : 'kDartessGreen'}},[_vm._v(" "+_vm._s(_vm.value ? "mdi-arrow-up" : "mdi-arrow-down")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }